import { Buffer3384y49aj0pxr as Buffer } from './Buffer.mjs';
import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
} from '../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { EOFException34hypof9gkxss as EOFException } from './NonJvmPlatform.mjs';
import {
  selectPrefix5tb3rl5iltlw as selectPrefix,
  readUtf8Line36yidw3sdfobh as readUtf8Line,
} from './internal/Buffer.mjs';
import {
  fromInt2ii0rejb1w62w as fromInt,
  add2suhfggl4zvkk as add,
  subtract2orl8z9upxd9l as subtract,
} from '../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import {
  _Char___init__impl__6a9atx2yltdocdrxs4d as _Char___init__impl__6a9atx,
  Char__toInt_impl_vasixd1ka89vowck9tn as Char__toInt_impl_vasixd,
} from '../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { toByte4i43936u611k as toByte } from '../../kotlin-kotlin-stdlib/kotlin/js/numberConversion.mjs';
import { commonIndexOf19ap7p38o0ad6 as commonIndexOf } from './internal/RealBufferedSource.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var RealBufferedSourceClass;
function RealBufferedSource() {
  if (RealBufferedSourceClass === VOID) {
    class $ {
      constructor(source) {
        this.c3u_1 = source;
        this.d3u_1 = false;
        this.e3u_1 = new (Buffer())();
      }
      v3v() {
        return this.e3u_1;
      }
      f3u(sink, byteCount) {
        var tmp$ret$0;
        $l$block_0: {
          // Inline function 'okio.internal.commonRead' call
          // Inline function 'kotlin.require' call
          if (!(byteCount >= 0n)) {
            var message = 'byteCount < 0: ' + byteCount.toString();
            throw IllegalArgumentException().o2(toString(message));
          }
          // Inline function 'kotlin.check' call
          if (!!this.d3u_1) {
            var message_0 = 'closed';
            throw IllegalStateException().o(toString(message_0));
          }
          if (this.e3u_1.l3s_1 === 0n) {
            if (byteCount === 0n) {
              tmp$ret$0 = 0n;
              break $l$block_0;
            }
            var read = this.c3u_1.f3u(this.e3u_1, 8192n);
            if (read === -1n) {
              tmp$ret$0 = -1n;
              break $l$block_0;
            }
          }
          // Inline function 'kotlin.comparisons.minOf' call
          var b = this.e3u_1.l3s_1;
          var toRead = byteCount <= b ? byteCount : b;
          tmp$ret$0 = this.e3u_1.f3u(sink, toRead);
        }
        return tmp$ret$0;
      }
      w3v() {
        // Inline function 'okio.internal.commonExhausted' call
        // Inline function 'kotlin.check' call
        if (!!this.d3u_1) {
          var message = 'closed';
          throw IllegalStateException().o(toString(message));
        }
        return this.e3u_1.w3v() && this.c3u_1.f3u(this.e3u_1, 8192n) === -1n;
      }
      x3v(byteCount) {
        // Inline function 'okio.internal.commonRequire' call
        if (!this.c3w(byteCount))
          throw EOFException().g3w();
        return Unit_instance;
      }
      c3w(byteCount) {
        var tmp$ret$0;
        $l$block: {
          // Inline function 'okio.internal.commonRequest' call
          // Inline function 'kotlin.require' call
          if (!(byteCount >= 0n)) {
            var message = 'byteCount < 0: ' + byteCount.toString();
            throw IllegalArgumentException().o2(toString(message));
          }
          // Inline function 'kotlin.check' call
          if (!!this.d3u_1) {
            var message_0 = 'closed';
            throw IllegalStateException().o(toString(message_0));
          }
          while (this.e3u_1.l3s_1 < byteCount) {
            if (this.c3u_1.f3u(this.e3u_1, 8192n) === -1n) {
              tmp$ret$0 = false;
              break $l$block;
            }
          }
          tmp$ret$0 = true;
        }
        return tmp$ret$0;
      }
      p3w(options) {
        var tmp$ret$0;
        $l$block_1: {
          // Inline function 'okio.internal.commonSelect' call
          // Inline function 'kotlin.check' call
          if (!!this.d3u_1) {
            var message = 'closed';
            throw IllegalStateException().o(toString(message));
          }
          while (true) {
            var index = selectPrefix(this.e3u_1, options, true);
            switch (index) {
              case -1:
                tmp$ret$0 = -1;
                break $l$block_1;
              case -2:
                if (this.c3u_1.f3u(this.e3u_1, 8192n) === -1n) {
                  tmp$ret$0 = -1;
                  break $l$block_1;
                }

                break;
              default:
                var selectedSize = options.t3s_1[index].q2();
                this.e3u_1.m3s(fromInt(selectedSize));
                tmp$ret$0 = index;
                break $l$block_1;
            }
          }
        }
        return tmp$ret$0;
      }
      m3w() {
        return this.n3w(9223372036854775807n);
      }
      n3w(limit) {
        var tmp$ret$0;
        $l$block_0: {
          // Inline function 'okio.internal.commonReadUtf8LineStrict' call
          // Inline function 'kotlin.require' call
          if (!(limit >= 0n)) {
            var message = 'limit < 0: ' + limit.toString();
            throw IllegalArgumentException().o2(toString(message));
          }
          var tmp;
          if (limit === 9223372036854775807n) {
            tmp = 9223372036854775807n;
          } else {
            // Inline function 'kotlin.Long.plus' call
            tmp = add(limit, fromInt(1));
          }
          var scanLength = tmp;
          // Inline function 'kotlin.code' call
          var this_0 = _Char___init__impl__6a9atx(10);
          var tmp$ret$4 = Char__toInt_impl_vasixd(this_0);
          var newline = this.o3w(toByte(tmp$ret$4), 0n, scanLength);
          if (!(newline === -1n)) {
            tmp$ret$0 = readUtf8Line(this.e3u_1, newline);
            break $l$block_0;
          }
          var tmp_0;
          var tmp_1;
          var tmp_2;
          if (scanLength < 9223372036854775807n && this.c3w(scanLength)) {
            // Inline function 'kotlin.Long.minus' call
            var tmp$ret$5 = subtract(scanLength, fromInt(1));
            var tmp_3 = this.e3u_1.z3t(tmp$ret$5);
            // Inline function 'kotlin.code' call
            var this_1 = _Char___init__impl__6a9atx(13);
            var tmp$ret$6 = Char__toInt_impl_vasixd(this_1);
            tmp_2 = tmp_3 === toByte(tmp$ret$6);
          } else {
            tmp_2 = false;
          }
          if (tmp_2) {
            // Inline function 'kotlin.Long.plus' call
            var tmp$ret$7 = add(scanLength, fromInt(1));
            tmp_1 = this.c3w(tmp$ret$7);
          } else {
            tmp_1 = false;
          }
          if (tmp_1) {
            var tmp_4 = this.e3u_1.z3t(scanLength);
            // Inline function 'kotlin.code' call
            var this_2 = _Char___init__impl__6a9atx(10);
            var tmp$ret$8 = Char__toInt_impl_vasixd(this_2);
            tmp_0 = tmp_4 === toByte(tmp$ret$8);
          } else {
            tmp_0 = false;
          }
          if (tmp_0) {
            tmp$ret$0 = readUtf8Line(this.e3u_1, scanLength);
            break $l$block_0;
          }
          var data = new (Buffer())();
          // Inline function 'okio.minOf' call
          var b = this.e3u_1.l3s_1;
          // Inline function 'kotlin.comparisons.minOf' call
          var a = fromInt(32);
          var tmp$ret$9 = a <= b ? a : b;
          this.e3u_1.d3w(data, 0n, tmp$ret$9);
          // Inline function 'kotlin.comparisons.minOf' call
          var a_0 = this.e3u_1.l3s_1;
          var tmp$ret$11 = a_0 <= limit ? a_0 : limit;
          throw EOFException().b3w('\\n not found: limit=' + tmp$ret$11.toString() + ' content=' + data.h3w().g3v() + '\u2026');
        }
        return tmp$ret$0;
      }
      m3s(byteCount) {
        // Inline function 'okio.internal.commonSkip' call
        var byteCount_0 = byteCount;
        // Inline function 'kotlin.check' call
        if (!!this.d3u_1) {
          var message = 'closed';
          throw IllegalStateException().o(toString(message));
        }
        while (byteCount_0 > 0n) {
          if (this.e3u_1.l3s_1 === 0n && this.c3u_1.f3u(this.e3u_1, 8192n) === -1n) {
            throw EOFException().g3w();
          }
          var tmp0 = byteCount_0;
          // Inline function 'kotlin.comparisons.minOf' call
          var b = this.e3u_1.l3s_1;
          var toSkip = tmp0 <= b ? tmp0 : b;
          this.e3u_1.m3s(toSkip);
          byteCount_0 = subtract(byteCount_0, toSkip);
        }
        return Unit_instance;
      }
      o3w(b, fromIndex, toIndex) {
        var tmp$ret$0;
        $l$block_0: {
          // Inline function 'okio.internal.commonIndexOf' call
          var fromIndex_0 = fromIndex;
          // Inline function 'kotlin.check' call
          if (!!this.d3u_1) {
            var message = 'closed';
            throw IllegalStateException().o(toString(message));
          }
          // Inline function 'kotlin.require' call
          if (!(0n <= fromIndex_0 ? fromIndex_0 <= toIndex : false)) {
            var message_0 = 'fromIndex=' + fromIndex_0.toString() + ' toIndex=' + toIndex.toString();
            throw IllegalArgumentException().o2(toString(message_0));
          }
          while (fromIndex_0 < toIndex) {
            var result = this.e3u_1.o3w(b, fromIndex_0, toIndex);
            if (!(result === -1n)) {
              tmp$ret$0 = result;
              break $l$block_0;
            }
            var lastBufferSize = this.e3u_1.l3s_1;
            if (lastBufferSize >= toIndex || this.c3u_1.f3u(this.e3u_1, 8192n) === -1n) {
              tmp$ret$0 = -1n;
              break $l$block_0;
            }
            // Inline function 'kotlin.comparisons.maxOf' call
            var a = fromIndex_0;
            fromIndex_0 = a >= lastBufferSize ? a : lastBufferSize;
          }
          tmp$ret$0 = -1n;
        }
        return tmp$ret$0;
      }
      c3x(targetBytes) {
        return this.d3x(targetBytes, 0n);
      }
      d3x(targetBytes, fromIndex) {
        var tmp$ret$0;
        $l$block_0: {
          // Inline function 'okio.internal.commonIndexOfElement' call
          var fromIndex_0 = fromIndex;
          // Inline function 'kotlin.check' call
          if (!!this.d3u_1) {
            var message = 'closed';
            throw IllegalStateException().o(toString(message));
          }
          while (true) {
            var result = this.e3u_1.d3x(targetBytes, fromIndex_0);
            if (!(result === -1n)) {
              tmp$ret$0 = result;
              break $l$block_0;
            }
            var lastBufferSize = this.e3u_1.l3s_1;
            if (this.c3u_1.f3u(this.e3u_1, 8192n) === -1n) {
              tmp$ret$0 = -1n;
              break $l$block_0;
            }
            // Inline function 'kotlin.comparisons.maxOf' call
            var a = fromIndex_0;
            fromIndex_0 = a >= lastBufferSize ? a : lastBufferSize;
          }
        }
        return tmp$ret$0;
      }
      e3x(offset, bytes) {
        return this.g3u(offset, bytes, 0, bytes.q2());
      }
      g3u(offset, bytes, bytesOffset, byteCount) {
        var tmp$ret$0;
        $l$block_2: {
          // Inline function 'okio.internal.commonRangeEquals' call
          // Inline function 'kotlin.check' call
          if (!!this.d3u_1) {
            var message = 'closed';
            throw IllegalStateException().o(toString(message));
          }
          if (byteCount < 0) {
            tmp$ret$0 = false;
            break $l$block_2;
          }
          if (offset < 0n) {
            tmp$ret$0 = false;
            break $l$block_2;
          }
          if (bytesOffset < 0 || (bytesOffset + byteCount | 0) > bytes.q2()) {
            tmp$ret$0 = false;
            break $l$block_2;
          }
          if (byteCount === 0) {
            tmp$ret$0 = true;
            break $l$block_2;
          }
          // Inline function 'kotlin.Long.plus' call
          var tmp$ret$3 = add(offset, fromInt(1));
          tmp$ret$0 = !(commonIndexOf(this, bytes, bytesOffset, byteCount, offset, tmp$ret$3) === -1n);
        }
        return tmp$ret$0;
      }
      l6() {
        var tmp$ret$0;
        $l$block: {
          // Inline function 'okio.internal.commonClose' call
          if (this.d3u_1) {
            tmp$ret$0 = Unit_instance;
            break $l$block;
          }
          this.d3u_1 = true;
          this.c3u_1.l6();
          this.e3u_1.s4();
          tmp$ret$0 = Unit_instance;
        }
        return tmp$ret$0;
      }
      toString() {
        // Inline function 'okio.internal.commonToString' call
        return 'buffer(' + toString(this.c3u_1) + ')';
      }
    }
    initMetadataForClass($, 'RealBufferedSource');
    RealBufferedSourceClass = $;
  }
  return RealBufferedSourceClass;
}
//region block: exports
export {
  RealBufferedSource as RealBufferedSource2k7dkofmgqbx9,
};
//endregion

//# sourceMappingURL=RealBufferedSource.mjs.map
